    <div class="modal-header">
      <h3>Qual perfil escolher?</h3>
      <a (click)="close()" class="closebtn">x</a>
    </div>

    <div class="modal-body">
      <div class="card-item">
        <div class="icon">
          <span class="material-icons-outlined">
            person_outline
          </span>
        </div>
        <div class="item-text">
          <h4>Pessoa Física (Investidor)</h4>
          <p>
            Para você que é um investidor individual.
            Escolha esta opção se você investe com seu CPF em produtos garantidos pelo FGC,
            como CDB, LCI, LCA, poupança ou outros investimentos em seu nome.
          </p>
        </div>

      </div>
      <hr>
      <div class="card-item">
        <div class="icon">
          <span class="material-icons-outlined">
            corporate_fare
          </span>
        </div>
        <div class="item-text">
          <h4>Pessoa Jurídica (Investidor)</h4>
        <p>
          Para empresas que investem recursos próprios.
          Escolha esta opção se sua empresa possui CNPJ e realiza investimentos em produtos cobertos pela garantia do FGC.
        </p>
        </div>

      </div>
      <hr>
      <div class="card-item">
        <div class="icon">
          <span class="material-icons-outlined">
            trending_up
          </span>
        </div>
        <div class="item-text">
          <h4>Fundo de Investimento</h4>
          <p>
            Para fundos de investimento devidamente registrados na CVM.
            Escolha esta opção se você representa um fundo que possui aplicações em produtos garantidos pelo FGC.
          </p>
        </div>

      </div>
      <hr>
      <div class="card-item">
        <div class="icon">
          <span class="material-icons-outlined">
            real_estate_agent
          </span>
        </div>
        <div class="item-text">
          <h4>Corretoras / Administradoras / DTVM's</h4>
        <p>
          Para instituições financeiras autorizadas pelo Banco Central ou CVM.
          Escolha esta opção se você representa uma corretora de valores,
          administradora de recursos ou distribuidora de títulos e valores mobiliários.
        </p>
        </div>

      </div>
      <hr>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn btn-custom" (click)="close()">Entendi</button>
    </div>
